module.exports = __webpack_public_path__ + "static/sharepoint-793f11bf4195665085fd013fdabfe5ac.png";